import type {ReactElement} from 'react';
import type {Editor} from 'grapesjs';
import {UserSaveConflictPopup} from '@Components/user-save-conflict-popup/user-save-conflict-popup';
import {EditorType} from '@Utils/misc.util';
import {EmailMakerSaveErrorCode, saveEmailTemplateToCache} from '@EmailMakerReact/lib/email-maker-storage-library';
import {SaveActionType} from '@EmailMakerReact/grapesjs-email-maker-plugin/src/email-maker-plugin.types';
import type {EmailMakerSaveErrorState} from '@EmailMakerReact/email-maker-react.types';
import styles from './email-maker-save-conflict-popover.module.scss';

interface EmailMakerSaveConflictPopoverProps {
  editor: Editor | null;
  saveError: EmailMakerSaveErrorState | null;
}

/** UserSaveConflictPopup self-switches: an inline card on desktop, an opened modal on mobile/tablet. */
export function EmailMakerSaveConflictPopover({editor, saveError}: EmailMakerSaveConflictPopoverProps): ReactElement | null {
  if (!editor || saveError?.code !== EmailMakerSaveErrorCode.EXISTING_SAVE_DATA || !saveError.conflictPayload) {
    return null;
  }

  const resolvedEditor = editor;
  const payload = saveError.conflictPayload;

  function handleAcceptYours(): void {
    void saveEmailTemplateToCache(resolvedEditor, {saveActionType: SaveActionType.ACCEPT_YOURS});
  }

  function handleAcceptTheirs(): void {
    window.location.reload();
  }

  return (
    <div className={styles.popover}>
      <UserSaveConflictPopup
        currentUserPictureURL={payload.currentUserPictureURL}
        otherUserPictureURL={payload.otherUserPictureURL}
        otherUserName={payload.otherUserName}
        editorType={EditorType.EMAIL}
        onAcceptYours={handleAcceptYours}
        onAcceptTheirs={handleAcceptTheirs}
      />
    </div>
  );
}
